export default __webpack_public_path__ + "static/media/KOD0055-min.e5c45179.webp";